
<div class="row">
    <div class="col-12" *ngFor="let alerta of this.SYS41ARC">
        <button type="button" class="btn btn-warning centrar">
            <i class="bx bx-error font-size-16 align-middle me-2"></i>
            {{ alerta.SYS41MSG }}
        </button>
    </div>
</div>